export function linkToClinicAdmin() {
  return "/clinic-admin";
}

export function linkToClinicAdminBillingManagement() {
  return `${linkToClinicAdmin()}/billing-management`;
}

export function linkToClinicAdminControlPanel() {
  return `${linkToClinicAdmin()}/control-panel`;
}

export function linkToClinicAdminFacilityReports() {
  return `${linkToClinicAdmin()}/facility-reports`;
}
